// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table, Button, Input } from 'semantic-ui-react';
import _ from 'lodash';
// local
// views
import Page from 'app/ui/pages/Page';
import EmptyList from 'app/ui/commons/emptyList/EmptyList';
import PatientModal from 'app/ui/modal/PatientModal';
import EnablePatientModal from 'app/ui/modal/EnablePatientModal';
import DisablePatientModal from 'app/ui/modal/DisablePatientModal';
import PatientDeactivateError from 'app/ui/modal/PatientDisableErrorModal';
import PopupPatient from './PopupPatient';
// consts
import { TYPE as CLIENT_TYPE } from 'salvus-shared/consts/client';
import { PROFILE } from 'salvus-shared/consts/account';
// views
import FilterUseType from 'app/ui/commons/filterusertype/FilterUseType';
// actions
import { openSave, TYPE } from 'app/redux/actions/modal';
import { list, search, filter, openDetail, reset } from 'app/redux/actions/patient/data';
import { init } from 'app/redux/actions/patient/enableModal';
import { deinit } from 'app/redux/actions/patient/disableModal';
// libs
import t from 'app/lib/i18n';
// css
import './Patients.css';

class Patients extends Component {
    constructor(props) {
        super(props);
        this.callSearch = _.debounce(this.callSearch, 100);
        this.state = {
            search: props.patient.filter.term,
        };
    }

    componentDidMount = () => this.props.dispatch(list());

    componentWillUnmount = () => this.props.dispatch(reset());

    // Handle clicks in the add patient button
    onClickAdd = () => this.props.dispatch(openSave(TYPE.PATIENT));

    // Handle the confirm initialize patient
    onConfirmInitialize = (id, form) => this.props.dispatch(init(id, form));

    // Handle the confirm deactivate patient
    onConfirmDeactivate = (id, form) => this.props.dispatch(deinit(id, form));

    // Handler for the events from the filter Checkbox
    onFilterChange = value => this.props.dispatch(filter(value));

    // Handler for the change in the input
    onSearchChange = (e, { value }) => {
        this.setState({ search: value });
        this.callSearch(value);
    };

    callSearch = value => this.props.dispatch(search(value));

    // Handler for the click in the patient row
    onClickRow = id => () => this.props.dispatch(openDetail(id));

    renderEmpty = () => <EmptyList emptyMessage="Nenhum paciente encontrado." />;

    renderTable(data) {
        const { auth } = this.props;
        return (
            <Table id="list-patients">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell textAlign="center" width="1">
                            ATM
                        </Table.HeaderCell>
                        <Table.HeaderCell width="3">NOME</Table.HeaderCell>
                        <Table.HeaderCell textAlign="center" width="2">
                            TELEFONES
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="center" width="2">
                            CPF
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="center" width="1">
                            PRESCRIÇÃO
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="center" width="3">
                            PLANO DE SAÚDE
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="center" width="1">
                            PERÍODO
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="center" width="3">
                            FORNECEDOR
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="center" width="1">
                            STATUS
                        </Table.HeaderCell>
                        {!(auth.account.client.type === CLIENT_TYPE.SALVUS && auth.account.profile === PROFILE.DEFAULT) && <Table.HeaderCell width="1" />}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {_.map(data, row => {
                        const supplier = row.supplier ? row.supplier.name : '-';
                        return (
                            <Table.Row key={row.id} onClick={this.onClickRow(row.id)}>
                                <Table.Cell textAlign="center" width="1">
                                    {row.serviceNumber}
                                </Table.Cell>
                                <Table.Cell className="uppercase wrap" width="3">
                                    {row.name}
                                </Table.Cell>
                                <Table.Cell textAlign="center" className="bold" width="2">
                                    {row.phone1 ? <p className="no-margin">{row.phone1}</p> : null}
                                    {row.phone2 ? <p className="no-margin">{row.phone2}</p> : null}
                                    {row.phone3 ? <p className="no-margin">{row.phone3}</p> : null}
                                </Table.Cell>
                                <Table.Cell textAlign="center" width="2">
                                    {row.cpf}
                                </Table.Cell>
                                <Table.Cell textAlign="center" className="prescription-column" width="1">
                                    {row.prescription} L/min
                                </Table.Cell>
                                <Table.Cell textAlign="center" className="wrap" width="3">
                                    {row.healthInsurence}
                                </Table.Cell>
                                <Table.Cell textAlign="center" width="1">
                                    {t(`patient_period_type_${row.periodType}`)}
                                </Table.Cell>
                                <Table.Cell textAlign="center" className="wrap" width="3">
                                    {supplier}
                                </Table.Cell>
                                <Table.Cell textAlign="center" className={`patient_status_${row.status}`} width="1">
                                    {t(`patient_status_${row.status}`)}
                                </Table.Cell>
                                {!(auth.account.client.type === CLIENT_TYPE.SALVUS && auth.account.profile === PROFILE.DEFAULT) && (
                                    <Table.Cell textAlign="right" width="1">
                                        <PopupPatient row={row} allPatients={filter.data} />
                                    </Table.Cell>
                                )}
                            </Table.Row>
                        );
                    })}
                </Table.Body>
            </Table>
        );
    }

    render() {
        const { auth, patient } = this.props;
        const { filter } = patient;
        return (
            <Page id="page-patient" loading={patient.loading}>
                <div className="page-header">
                    <div className="page-title">PACIENTES</div>
                    {!(auth.account.client.type === CLIENT_TYPE.SALVUS && auth.account.profile === PROFILE.DEFAULT) && (
                        <Button content="Adicionar" onClick={this.onClickAdd} />
                    )}
                </div>
                <div className="body">
                    <div className="body-header">
                        <Input id="patient-search" placeholder="Pesquisar..." className="search" onChange={this.onSearchChange} value={this.state.search} />
                        <div>
                            <FilterUseType checked={filter.type} onChange={this.onFilterChange} />
                        </div>
                    </div>
                    {_.isEmpty(filter.data) ? this.renderEmpty() : this.renderTable(filter.data)}
                </div>
                <PatientModal />
                <EnablePatientModal onConfirmInitialize={this.onConfirmInitialize} />
                <DisablePatientModal onConfirmDeactivate={this.onConfirmDeactivate} />
                <PatientDeactivateError />
            </Page>
        );
    }
}

Patients.propTypes = {
    auth: PropTypes.object,
    patient: PropTypes.object,
    dispatch: PropTypes.func,
    init: PropTypes.object,
};

const mapStateToProps = state => ({
    auth: state.auth,
    patient: state.patient,
});
export default connect(mapStateToProps)(Patients);
